import React from "react";
import PropTypes from "prop-types";
import ShowHideColumnModal from "../common/columnModal/ShowHideColumnModal";
import { ALL_COLUMNS, DEFAULT_COLUMNS } from "./../../pages/price-check/utils";

const PriceCheckShowHideColumnModal = ({
  isShowHideColumn,
  setIsShowHideColumn,
  settingColumn,
  columns,
}) => {
  return (
    <ShowHideColumnModal
      isShowHideColumn={isShowHideColumn}
      setIsShowHideColumn={setIsShowHideColumn}
      settingColumn={settingColumn}
      columns={columns}
      allColumns={ALL_COLUMNS}
      defaultColumns={DEFAULT_COLUMNS}
      title="Show / hide columns"
    />
  );
};

PriceCheckShowHideColumnModal.propTypes = {
  isShowHideColumn: PropTypes.bool.isRequired,
  setIsShowHideColumn: PropTypes.func.isRequired,
  settingColumn: PropTypes.func.isRequired,
  columns: PropTypes.array.isRequired,
};

export default PriceCheckShowHideColumnModal;
